module.exports = __webpack_public_path__ + "prod/1.42.2/img/sinaa.126e9fc0.svg";